<template>
  <div>
    <el-dialog
      class="weixin-qrcode-pay"
      width="860px"
      :visible.sync="isVisibleTmp"
      :before-close="handleClose"
    >
      <div
        class="pay-content"
        v-if="!isPayFail"
      >
        <div class="weixinQRCodePayTitle">
          <div class="weixinQRCodePayTitle_left">{{weixinPay.desc}}。订单号：{{weixinPay.outTradeNo}}</div>
          <div v-if="weixinPay.productId =='SMRZ1804' " style="color: #e31613;">交费后，请不要刷新或关闭本页面。请等待企业信息状态为“实名认证审核中”，再进行其它操作。</div>
        </div>
      </div>

      <div
        class="pay-coupon"
        v-if="!isPayFail"
      >
        <div class="pay-coupon-left">
          <span>请选择优惠券：</span>
          <el-select
            v-model="coupon.couponCode"
            placeholder="请选择优惠券"
            @change="couponChangeHandler"
          >
            <el-option
              v-for="item in coupon.sysCouponList"
              :key="item.couponCode"
              :label="item.couponName"
              :value="item.couponCode"
            >
            </el-option>
          </el-select>
        </div>
        <div class="pay-coupon-price">
          <span class="price-item">原价:
            <span class="price-item-padding">￥</span>
            <span>{{weixinPay.price |toFix2 }}</span>
          </span>
          <span class="price-item">优惠:
            <span class="price-item-padding">￥</span>
            <span>{{coupon.discountPrice |toFix2}}</span>
          </span>
          <span class="price-item">实付:
            <span class="price-item-padding">￥</span>
            <span class="price-item-red">{{coupon.afterDiscountPrice |toFix2}}</span>
          </span>
        </div>
      </div>
      <div class="coupon-tips">
        <span v-show="coupon.isTips">提示：依据腾讯支付规定，最低订单金额为￥0.01</span>
      </div>
      <div
        class="pay-content-box"
        v-if="!isPayFail"
      >
        <div class="pay-weixin-title">
          <div class="p-w-hd">微信支付</div>
          <div class="pay-weixin-title-time">
            <div
              class="payTime"
              v-if="payTime>0"
            > 距离二维码过期还剩
              <span>{{payTime}}</span> 秒，过期后请刷新页面重新获取二维码。</div>
            <div
              class="expired"
              v-if="payTime<=0"
            >二维码已过期，
              <span @click="createOpptyOrderQRCode"> 刷新</span>页面重新获取二维码。</div>
          </div>
        </div>
        <div class="pay-weixin-box">
          <div class="pay-weixin-qrCode">
            <canvas
              ref="weixinPayQRCode"
              id="weixinPayQRCode"
            ></canvas>
            <div class="pay-weixin-qrCode-bottom">
              <p>请使用微信扫一扫</p>
              <p>扫描二维码支付</p>
            </div>
          </div>
          <div class="pay-weixin-box-right"></div>
        </div>
      </div>
      <div
        class="pay-qrcode-fail"
        v-if="isPayFail"
      >
        <div class="pay-qrcode-fail_error">
          微信支付失败！<br> 请您检查相关信息后，重新支付。
        </div>
      </div>
      <br>
      <div
        class="pay-qrcode-confirm"
        v-if="isPayFail"
      >
        <el-button
          class="eb-button-orange eb-button-big"
          @click="isVisibleTmp = false"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from 'qrcode';
import EventBus from '@/plugins/event-bus';
import { unifiedorder, getOrderStatus } from '@/services/weixin-service';
import { setTimeout } from 'timers';
import { userSysCouponList } from '@/services/system-service';
import { placeOrder } from '@/services/busi/business-push-service';
import { concat } from 'lodash';
export default {
  props: {
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      weixinPay: {
        productId: null,
        outTradeNo: null,
        body: null,
        price: null,
        codeURL: '',
        desc: ''
      },
      payTime: '300',
      weixinOrderInfo: {},
      isPayFail: false,
      timer: null,
      timerOut: null,
      coupon: {
        sysCouponList: [
          {
            couponName: '不使用优惠',
            couponCode: 'noUse'
          }
        ],
        couponCode: null,
        afterDiscountPrice: 0,
        discountPrice: 0,
        isTips: false
      }
    };
  },
  computed: {
    isVisibleTmp: {
      get: function() {
        return this.isVisible;
      },
      set: function(val) {
        this.$emit('update:isVisible', val);
      }
    }
  },
  created() {
    EventBus.$off('initWeixinPayQRCode');
    EventBus.$on('initWeixinPayQRCode', params => {
      // 重置参数
      this.resetWeixinPay();

      // 设置新的参数
      this.weixinPay.productId = params.productId;
      this.weixinPay.outTradeNo = params.outTradeNo;
      this.weixinPay.body = params.body;
      this.weixinPay.desc = params.desc;
      this.weixinPay.orderParams = params.orderParams;
      this.placeOrderService(true);
    });
  },
  methods: {
    // 创建订单
    async placeOrderService(isInit) {
      try {
        // 获取订单编号
        let { data: data1 } = await placeOrder(this.weixinPay.orderParams);
        if (data1.returnCode === '01') {
          this.weixinPay.outTradeNo = data1.sysOrderNumber;
          this.weixinPay.price = data1.orderAmount;
          if (isInit) {
            this.userSysCouponListService();
          } else {
            this.createOpptyOrderQRCode();
          }
        } else {
          this.$message.error('生成订单失败');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    // 获取优惠券列表
    async userSysCouponListService() {
      try {
        let { data } = await userSysCouponList(this.weixinPay.outTradeNo);
        if (data.returnCode === '01') {
          this.coupon.sysCouponList = concat(this.coupon.sysCouponList, data.sysCouponList);
          if (this.coupon.sysCouponList && this.coupon.sysCouponList[1]) {
            this.coupon.couponCode = this.coupon.sysCouponList[1].couponCode;
          }
        } else {
          this.$message.error('获取优惠券列表失败');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
      this.createOpptyOrderQRCode();
    },
    // 选择优惠券
    couponChangeHandler: function() {
      this.placeOrderService();
    },
    // 计算优惠后价格
    couponPriceHandler: function() {
      var price = parseFloat(this.weixinPay.price);

      if (this.coupon.couponCode && this.coupon.couponCode !== 'noUse') {
        var chooseCoupon = this.chooseCouponData();
        var discountAmount = parseFloat(chooseCoupon.discountAmount);
        var couponType = chooseCoupon.couponType;

        if (couponType === '2') {
          price = price * discountAmount * 0.01;
        }
        if (couponType === '1') {
          price = price - discountAmount;
        }
      }
      if (price <= 0) {
        price = 0.01;
        this.coupon.isTips = true;
      } else {
        this.coupon.isTips = false;
      }
      this.coupon.afterDiscountPrice = price;
      this.coupon.discountPrice = parseFloat(this.weixinPay.price) - price;
    },
    // 返回选中的优惠券
    chooseCouponData: function() {
      if (this.coupon.sysCouponList) {
        for (var i = 0; i < this.coupon.sysCouponList.length; i++) {
          if (this.coupon.sysCouponList[i].couponCode === this.coupon.couponCode) {
            return this.coupon.sysCouponList[i];
          }
        }
      }
    },
    // 重置参数
    resetWeixinPay() {
      this.weixinPay.productId = null;
      this.weixinPay.outTradeNo = null;
      this.weixinPay.body = null;
      this.weixinPay.price = null;
      this.weixinPay.desc = null;
      this.weixinPay.orderParams = {};
      this.coupon = {
        sysCouponList: [
          {
            couponName: '不使用优惠',
            couponCode: 'noUse'
          }
        ],
        couponCode: null,
        afterDiscountPrice: 0,
        discountPrice: 0,
        isTips: false
      };
    },

    // 创建下单二维码
    async createOpptyOrderQRCode() {
      this.payTime = 300;
      this.$nextTick(async function() {
        try {
          this.couponPriceHandler();
          // 微信支付链接生成二维码
          let weixinPayQRCode = document.querySelector('#weixinPayQRCode');
          // 微信下单
          let params = {
            productId: this.weixinPay.productId,
            outTradeNo: this.weixinPay.outTradeNo,
            body: this.weixinPay.body,
            couponCode: this.coupon.couponCode
          };
          let { data } = await unifiedorder(params);
          if (data.returnCode === '01') {
            this.weixinOrderInfo = data;
          } else if (data.returnCode === '03') {
            throw new Error('微信下单，参数不完整');
          } else if (data.returnCode === '05') {
            throw new Error('微信下单，验证失败');
          } else {
            throw new Error('微信下单失败！');
          }

          let _this = this;
          QRCode.toCanvas(
            weixinPayQRCode,
            this.weixinOrderInfo.codeURL,
            {
              width: 298,
              height: 298,
              margin: 0
            },
            function(error) {
              if (error) {
                console.error(error);
              }
              _this.getOrderPayStatus();
            }
          );
          this.setTimer();
        } catch (error) {
          this.$message.error(error.message);
        }
      });
    },
    // 获取订单状态
    async getOrderPayStatus() {
      try {
        let { data } = await getOrderStatus(this.weixinPay.outTradeNo);
        if (data.returnCode === '01') {
          if (data.status === 'SUCCESS') {
            this.$emit('paymentComplete', {
              status: 'SUCCESS',
              outTradeNo: this.weixinPay.outTradeNo
            });
          } else if (data.status === 'NOTPAY') {
            let outTradeNo = this.weixinPay.outTradeNo;
            setTimeout(() => {
              if (outTradeNo === this.weixinPay.outTradeNo && this.isVisible === true) {
                this.getOrderPayStatus();
              }
            }, 2000);
          } else {
            // 支付失败
            this.isPayFail = true;
            this.$emit('paymentComplete', {
              status: 'ERROR'
            });
          }
        } else if (data.returnCode === '03') {
          throw new Error('请传入订单编号');
        } else {
          throw new Error('查询订单支付状态失败');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    setTimer: function() {
      this.clearTimer();
      this.timer = setInterval(() => {
        if (this.payTime <= 0) {
          clearInterval(this.timer);
          this.timer = null;
        } else {
          this.payTime--;
        }
      }, 1000);
    },
    handleClose: function() {
      this.clearTimer();
      this.isVisibleTmp = false;
    },
    clearTimer: function() {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  beforeDestroy() {
    this.clearTimer();
  }
};
</script>

<style lang="less" scoped>
.weixin-qrcode-pay {
  .pay-content {
    padding: 0 0 20px 0;
    margin-top: -20px;
  }
  .pay-content-box {
    background-color: #fff;
    padding: 12px 30px;
    box-shadow: 0 6px 32px rgba(0, 0, 0, 0.13);
    font: 12px/150% Arial, Verdana, '宋体';
    -webkit-font-smoothing: auto;
    color: #666;
    .pay-weixin-title {
      margin-bottom: 20px;
      display: flex;
      flex-wrap: wrap;
      .p-w-hd {
        font-size: 18px;
        font-family: 'Microsoft Yahei';
        padding-right: 18px;
      }
      .pay-weixin-title-time {
        font-family: 'Microsoft Yahei';
        font-size: 12px;
        .payTime {
          span {
            color: #e31613;
            font-weight: bold;
          }
        }
        .expired {
          color: #e31613;
          span {
            color: #67a4ff;
            cursor: pointer;
          }
        }
      }
    }
    .pay-weixin-box {
      display: flex;
      flex-wrap: wrap;
      .pay-weixin-qrCode {
        width: 300px;
        padding-left: 90px;
        .pay-weixin-qrCode-bottom {
          height: 44px;
          padding: 8px 0 8px 125px;
          background: #ff7674 url('../../../assets/img/pc_icon_icon-red.png') 50px 8px no-repeat;
          p {
            margin: 0;
            font-size: 14px;
            line-height: 24px;
            color: #fff;
            font-weight: 700;
          }
        }
      }
    }
    #weixinPayQRCode {
      height: 298px;
      width: 298px;
      border: 1px solid #ddd;
      margin-bottom: 20px;
    }
    .pay-weixin-box-right {
      width: 340px;
      height: 421px;
      padding-left: 30px;
      margin-top: -20px;
      background: url('../../../assets/img/pc_icon_phone-bg.png') 30px 0 no-repeat;
    }
  }
  .pay-qrcode-fail {
    display: flex;
    justify-content: center;
    .pay-qrcode-fail_error {
      width: 300px;
    }
  }
  .pay-qrcode-confirm {
    display: flex;
    justify-content: center;
  }
  .weixinQRCodePayTitle {
    -webkit-font-smoothing: auto;
    .weixinQRCodePayTitle_left {
      line-height: 26px;
      height: 26px;
      overflow: hidden;
      color: #333;
      font-weight: 400;
      font-size: 14px;
      font-family: 'Microsoft Yahei';
      word-wrap: normal;
    }
  }
  .pay-coupon {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .pay-coupon-left {
    flex: 1;
  }
  .pay-coupon-price {
    flex: 1;
    display: flex;
    justify-content: space-between;
  }
  .price-item {
  }
  .price-item-red {
    font-size: 18px;
    color: #e31613;
    font-weight: bold;
    font-family: Arial, Verdana;
    position: relative;
    top: 1px;
  }
  .price-item-padding {
    padding-left: 5px;
  }
  .coupon-tips {
    height: 36px;
    text-align: right;
  }
}
</style>
